// DevHub: check whether the search index is still building (cold start), so the UI can show a
// "warming up" hint instead of a false "no results". Backed by GET /api/search-status
// (searchStatusModule). Fail-open: any error → not warming (never block a genuine empty result).
import { useCallback } from 'react';
import { useApi, configApiRef, fetchApiRef } from '@backstage/core-plugin-api';

export function useSearchStatus() {
  const fetchApi = useApi(fetchApiRef);
  const config = useApi(configApiRef);
  const backendUrl = config.getString('backend.baseUrl');

  // Returns true when the index is NOT ready yet (i.e. a zero-result is likely just "warming up").
  return useCallback(async (): Promise<boolean> => {
    try {
      const res = await fetchApi.fetch(`${backendUrl}/api/search-status`);
      if (!res.ok) return false;
      const data: unknown = await res.json();
      return (
        typeof data === 'object' &&
        data !== null &&
        'ready' in data &&
        (data as { ready: unknown }).ready === false
      );
    } catch {
      return false;
    }
  }, [fetchApi, backendUrl]);
}
